const React = require("react")
const { Arrow } = require("../menu/icons/arrow")

module.exports = {
  Arrow: (props) => <Arrow {...props} />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/invoicesPaid/index.js